<template>
  <div id="examuser">
    <!-- {{PlugJson}} -->
    <van-collapse v-model="activeName" accordion>
      <van-collapse-item title="标题1" :name="0">
        <template
          slot="title"
        >{{(PlugJson.PlugBody.ExamUserCount)?'机构工作人员'+PlugJson.PlugBody.ExamUserCount+'人':'未登记机构工作人员信息'}}</template>
        <van-cell
          v-for="(item,index) in PlugJson.PlugBody.ExamUserList"
          :key="index"
        >
          <template slot="title">
            <b>{{item.RealName}}</b>
            <small>({{item.RoleName}})</small>
          </template>
          <template slot="default">
            <span class="fa fa-fw fa-phone color-blue"></span>
            <a class="color-blue" :href="'tel:'+item.Phone"><!-- {{item.Phone}} --></a>
          </template>
        </van-cell>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
export default {
  name: "examuser",
  props: {
    PlugJson: Object
  },
  data() {
    return {
      activeName: 1
    };
  }
};
</script>

<style scoped>
</style>